import { Box } from "@mui/material"
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom"
import BarCard from "./components/BarCard"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import StakeModal from "./components/StakeModal"
import useXFerState from "./hooks/useXFerState"
import {
  usePollFerroBoostPoolData,
  usePollUserFerroBar,
  usePollUserFerroBoost,
} from "src/state/xFer/hooks"
import { useWeb3React } from "@web3-react/core"
import DepositModal from "./components/DepositModal"
import UpgradeModal from "./components/UpgradeModal"
import { BigNumber } from "ethers"
import WithdrawModal from "./components/WithdrawModal"
import Switch from "src/components/Switch"
import Text from "src/components/Text"
import Container from "src/components/PageContainer"
import MyEarnings from "./components/MyEarnings"
import MyVault from "./components/MyVault"
import CustomCard from "src/components/CustomCard"
import usePastWeekApr from "./hooks/usePastWeekApr"
import { usePollPastWeekApr } from "./hooks/usePollPastWeekApr"

function Stake() {
  const [tabIndex, setTabIndex] = useState(0)
  const { account } = useWeb3React()

  const { t } = useTranslation()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const {
    openedStakeModal,
    openedDepositModal,
    openedUpgradeModal,
    openedWithdrawModal,
  } = useXFerState()
  const navigate = useNavigate()

  const handleItemClick = (value: number) => {
    setTabIndex(value)
    if (value === 0) {
      navigate("/stake/bar")
    } else {
      navigate("/stake/vault")
    }
  }

  const apr = usePastWeekApr()

  // Poll user data for xFER
  usePollUserFerroBar(account)
  usePollUserFerroBoost(account)
  usePollFerroBoostPoolData()
  usePollPastWeekApr()

  useEffect(() => {
    if (location.pathname === "/stake/vault") {
      setTabIndex(1)
    } else if (location.pathname === "/stake/bar") {
      setTabIndex(0)
    }
  }, [location])

  return (
    <Container>
      <Box maxWidth="596px" mx="auto" p={2}>
        <Text variant="h2" textAlign="center" mb={3}>
          {tabIndex === 0 ? t("Stake FER") : t("xFER Vault")}
        </Text>
        <CustomCard
          withGradient
          variant={tabIndex === 1 ? "darker-gray" : "darkest-gray"}
        >
          <Box textAlign="center" mb={3}>
            <Switch
              tabs={[
                { label: t("Stake"), value: 0 },
                { label: t("Vault"), value: 1 },
              ]}
              activeValue={tabIndex}
              onChange={handleItemClick}
            />
          </Box>
          <Routes>
            <Route path="/bar" element={<BarCard apr={apr} />} />
            <Route
              path="/vault"
              element={<MyVault defaultOpenedPid={searchParams.get("pid")} />}
            />
            <Route path="*" element={<Navigate to="/stake/bar" replace />} />
          </Routes>
        </CustomCard>
        <Routes>
          <Route
            path="/vault"
            element={
              <CustomCard mt={3} withGradient variant="darkest-gray">
                <MyEarnings />
              </CustomCard>
            }
          />
        </Routes>
        <Box height="20px" />
        {openedStakeModal && (
          <StakeModal isUnstaking={openedStakeModal.isUnstaking} apr={apr} />
        )}
        {openedDepositModal && (
          <DepositModal
            defaultSelectedPool={openedDepositModal.defaultSelectedPool}
          />
        )}
        {openedUpgradeModal && (
          <UpgradeModal
            poolId={openedUpgradeModal.poolId}
            stakeIds={openedUpgradeModal.stakeIds}
            amount={BigNumber.from(openedUpgradeModal.amount)}
            lastUnlockTime={openedUpgradeModal.lastUnlockTime}
          />
        )}
        {openedWithdrawModal && (
          <WithdrawModal stakeIds={openedWithdrawModal.stakeIds} />
        )}
      </Box>
    </Container>
  )
}

export default Stake
